<template>
  <div class="definitions">
    <div>
      <v-col cols="4" :style="{ 'max-width': '400px', padding: '0' }">
        <v-form v-model="isFormValid" ref="form" lazy-validation>
          <div>
            <v-select
              label="Import Type"
              :items="importTypes"
              item-text="Text"
              item-value="Value"
              v-model="selectType"
              :loading="isLoadingTypes"
              outlined
              dense
              @change="changeType"
            >
            </v-select>
            <v-text-field
              v-if="newDefinition"
              label="Import Name"
              v-model="definitionName"
              :rules="rules"
              outlined
              dense
            >
            </v-text-field>
            <v-select
              v-else
              label="Import Definition"
              :items="importList"
              v-model="selectDefinition"
              item-text="ImportName"
              item-value="ImportId"
              outlined
              dense
              @change="changeImport"
            >
            </v-select>
          </div>
          <div v-if="editing || newDefinition">
            <v-text-field
              v-model="importDefinition.SkipRows"
              outlined
              dense
              type="number"
              label="Skip Rows"
              :readonly="!isEditMode"
            />
            <v-text-field
              v-model="importDefinition.Rows"
              outlined
              dense
              type="number"
              label="Rows Per Record"
              :readonly="!isEditMode"
            />
            <v-select
              label="File Type"
              :items="fileTypes"
              outlined
              dense
              v-model="importDefinition.FileType"
              :readonly="!isEditMode"
            >
            </v-select>
          </div>
        </v-form>
      </v-col>
    </div>
    <v-divider></v-divider>
    <div>
      <v-dialog v-model="saveAsDialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Save As</span>
          </v-card-title>
          <v-card-text>
            <v-form v-model="isSaveAsValid" ref="saveAsForm" lazy-validation>
              <v-text-field
                label="Save definition as"
                v-model="saveAsName"
                :rules="rules"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="saveAsDialog = false">Cancel</v-btn>
            <v-btn color="primary" depressed @click="saveDefinitionAs">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-data-table
        v-if="editing"
        :items="importDetails"
        :headers="detailHeaders"
        dense
        :items-per-page="-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  depressed
                  class="my-4"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="!isEditMode || !showFormButtons"
                  @click="newItem"
                >
                  New Item
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  {{ formTitle }}
                </v-card-title>
                <v-card-text>
                  <v-form ref="form" lazy-validation>
                    <v-row>
                      <v-col cols="4">
                        <v-select
                          v-model="editedItem.Tablename"
                          label="Table Name"
                          :items="tableList"
                          dense
                          @change="changeTable"
                        ></v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="editedItem.FieldName"
                          label="Field Name"
                          :items="fieldList"
                          item-text="Description"
                          item-value="ShortName"
                          dense
                          @change="changeField"
                        ></v-select>
                      </v-col>

                      <v-col cols="4">
                        <v-text-field
                          v-model="editedItem.StartAt"
                          label="Start At"
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-text-field
                          v-model="editedItem.Length"
                          label="Length"
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-select
                          v-model="editedItem.Format"
                          label="Format"
                          :items="formatList"
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="editedItem.DefaultValue"
                          label="Default Value"
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-text-field v-model="editedItem.Dp" label="Decimals" dense></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-checkbox v-model="editedItem.TotalRequired" label="Check Total"
                          >Total</v-checkbox
                        >
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined @click="close"> Cancel </v-btn>
                  <v-btn color="primary" depressed @click="save"> Save </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            :disabled="!isEditMode || !showFormButtons"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon small :disabled="!isEditMode || !showFormButtons" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </div>
    <v-footer
      v-if="showFormButtons"
      padless
      fixed
      outlined
      class="pl-5 pr-5 pt-3 pb-3"
      color="white"
      elevation="3"
    >
      <v-spacer></v-spacer>
      <v-btn
        v-if="!isEditMode"
        class="mr-4"
        color="error"
        :disabled="!isDefinitionSelected"
        outlined
        @click="deleteDefinition"
      >
        Delete
      </v-btn>
      <v-btn v-if="!isEditMode" class="mr-4" color="primary" outlined @click="createDefinition">
        New
      </v-btn>
      <v-btn
        v-if="!isEditMode"
        color="primary"
        :disabled="!isDefinitionSelected"
        outlined
        @click="editDefinition"
      >
        Edit
      </v-btn>
      <v-btn v-if="isEditMode" class="mr-4" color="primary" outlined @click="cancelDefinition">
        Cancel
      </v-btn>
      <v-btn
        v-if="isEditMode && !newDefinition"
        class="mr-4"
        color="primary"
        outlined
        @click="saveAs"
        >Save As</v-btn
      >
      <v-btn v-if="isEditMode" color="primary" depressed @click="saveDefinition">Save</v-btn>
    </v-footer>
    <Dialog ref="messageBox" />
  </div>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';

export default {
  components: { Dialog },
  name: 'ImportDefinitions',
  mounted: function () {
    this.getTableList();
  },
  data: () => ({
    dialog: false,
    saveAsDialog: false,
    dialogDelete: false,
    editIndex: -1,
    editedItem: {},
    selectedField: null,

    tableList: [],
    fieldList: [],
    currentTable: '',

    isEditMode: false,
    rules: [(v) => !!v || 'Required.'],
    isFormValid: false,
    isSaveAsValid: false,
    isLoadingTypes: false,

    newDefinition: false,
    saveAsName: '',
    definitionName: '',
    editing: false,
    skipRows: 1,
    rowsPerRecord: 1,
    fileTypes: ['CSV', 'Tab', 'Fixed', 'Excel'],
    selectType: '',
    selectDefinition: null,
    formatList: ['', 'dd/MM/yyyy', 'MM/dd/yyyy', 'yyyy/MM/dd', 'Numeric'],
    importList: [],
    importDefinition: null,
    importDetails: [],
    importTypes: [
      { Text: '', Value: '' },
      { Text: 'Monthly Payroll', Value: 'Monthly Payroll' },
      { Text: 'Member Data', Value: 'Member Data' },
      { Text: 'Beneficiaries', Value: 'Beneficiaries' },
      { Text: 'Investment Choices', Value: 'InvestChoice' },
      { Text: 'Investment Transactions', Value: 'Transactions' },
      { Text: 'Salary Data', Value: 'Salary' },
      { Text: 'Exit Deferred', Value: 'ExitDeferred' },
    ],
    detailHeaders: [
      { text: 'Table Name', value: 'Tablename' },
      { text: 'Field Name', value: 'FieldName' },
      { text: 'Start At', value: 'StartAt' },
      { text: 'Length', value: 'Length' },
      { text: 'FieldType', value: 'FieldType' },
      { text: 'Dp', value: 'Dp' },
      { text: 'Format', value: 'Format' },
      { text: 'DefaultValue', value: 'DefaultValue' },
      { text: 'Total', value: 'TotalRequired' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
  }),

  created() {
    this.getImportTypesList();
  },

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
    },
    showFormButtons() {
      const userPermission = this.$store.getters.getUserPermission(this.$route.path);
      if (userPermission && userPermission == 'Full') return true;

      return false;
    },
    isDefinitionSelected() {
      return !!this.importDefinition;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    selectDefinition(val) {
      this.isEditMode = false;
      if (!val) {
        this.editing = false;
        this.importDefinition = null;
      }
    },
  },

  methods: {
    editDefinition() {
      this.isEditMode = true;
    },
    changeField(item) {
      console.log(item);
      var field = this.fieldList.find((f) => f.ShortName === item);
      if (field) {
        console.log(field);
        this.editedItem.FieldType = field.Reference;
      }
    },
    saveAs() {
      this.saveAsName = null;
      this.saveAsDialog = true;
    },
    createDefinition() {
      this.isEditMode = true;
      this.importDefinition = {};
      this.importDetails = [];
      this.definitionName = null;
      this.editing = false;
      this.newDefinition = true;
    },
    async saveDefinitionAs() {
      this.isSaveAsValid = this.$refs.saveAsForm.validate();
      if (!this.isSaveAsValid) return;
      try {
        this.importDefinition.ImportName = this.saveAsName;
        await this.$api.post('/Import/SaveDefinitionAs', this.importDefinition);

        this.saveAsDialog = false;
        this.cancelDefinition();
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Definition is saved as ' + this.saveAsName,
        });
      } catch (err) {
        console.error(err);
      }
    },
    async saveDefinition() {
      this.isFormValid = this.$refs.form.validate();
      if (!this.isFormValid) return;
      try {
        if (this.newDefinition) {
          this.importDefinition.ImportType = this.selectType;
          this.importDefinition.ImportName = this.definitionName;
        }
        let response = await this.$api.post(
          '/Import/UpdateImportDefinition',
          this.importDefinition
        );
        var result = response.data;

        if (this.newDefinition) {
          this.changeImport(result.Value);
        } else {
          this.cancelDefinition();
        }

        this.cancelDefinition();
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Definition is saved',
        });
      } catch (err) {
        console.error(err);
      }
    },
    async deleteDefinition() {
      var id = this.importDefinition.ImportId;

      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this definition?'
        );

        await this.$api.delete('/import/DeleteImportDefinition?Id=' + id);

        this.cancelDefinition();
        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Definition is deleted',
        });
      } catch (error) {
        console.log(error.message);
      }
    },
    cancelDefinition() {
      this.selectType = '';
      this.selectDefinition = null;

      this.editing = false;
      this.newDefinition = false;
      this.importDefinition = null;
      this.isEditMode = false;
    },
    async changeTable(item) {
      try {
        var data = { params: { formName: item, planId: 0 } };
        let response = await this.$api.get('/DataDictionary/GetFieldList', data);
        this.fieldList = response.data;
      } catch (err) {
        console.error(err);
      }
    },
    async getTableList() {
      try {
        let response = await this.$api.get('/DataDictionary/GetFormList');
        this.tableList = response.data;
      } catch (err) {
        console.error(err);
      }
    },

    async getImportTypesList() {
      this.isLoadingTypes = true;
      try {
        const response = await this.$api.get('/Import/GetImportTypes');
        this.importTypes = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingTypes = false;
      }
    },

    async changeImport(item) {
      try {
        let response = await this.$api.get('/import/GetImportDefinition?importId=' + item);

        if (!response.data) {
          const msg = 'Unable to load import definition';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.importDefinition = response.data;
        this.importDetails = this.importDefinition.Details;
        //this.selectType = response.data.ImportType;
        //await this.changeType(this.selectType);
        this.selectDefinition = response.data.ImportId;
        this.editing = true;
      } catch (err) {
        console.error(err);
      }
    },
    async reloadDetails() {
      try {
        let response = await this.$api.get(
          '/import/ReloadDetails?importid=' + this.importDefinition.ImportId
        );
        this.importDetails = response.data;
      } catch (err) {
        console.error(err);
      }
    },
    async changeType(item) {
      try {
        let response = await this.$api.get('/import/GetImportDefinitions?importtype=' + item);
        this.importList = [];
        this.selectDefinition = null;
        if (response.data != null) {
          response.data.forEach((item) => {
            this.importList.push(item);
          });
        } else {
          const msg = 'Unable to load import definition';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
      } catch (err) {
        console.error(err);
      }
      console.log(item);
    },

    editItem(item) {
      console.log(item);
      if (this.currentTable != item.Tablename) {
        this.changeTable(item.Tablename);
      }
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      try {
        await this.$refs.messageBox.open(
          'Confirmation',
          'Are you sure you wish to delete this record?'
        );
        this.deleteItemConfirm();
      } catch (error) {
        console.log(error);
      }
    },

    async deleteItemConfirm() {
      try {
        this.editedItem.ImportId = this.importDefinition.ImportId;
        await this.$api.delete('/import/DeleteImportDetail?id=' + this.editedItem.ImportLineId);

        this.reloadDetails();
        this.close();
        this.closeDelete();
      } catch (err) {
        console.error(err);
      }
    },

    close() {
      this.dialog = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
    newItem() {
      this.editedItem = { ImportId: this.importDefinition.ImportId, ImportLineId: 0 };
    },
    async save() {
      try {
        this.editedItem.ImportId = this.importDefinition.ImportId;
        await this.$api.post('/import/UpdateImportDetail', this.editedItem);

        this.reloadDetails();
        this.close();
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.definitions {
  margin-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;

  .v-data-table tbody tr {
    cursor: default;
  }

  .v-toolbar__content {
    padding: 0 !important;
  }
}
</style>
